import { Translation } from '@jsverse/transloco';
import { Observable } from 'rxjs';

export interface TranslationLoadingStrategy {
  loadGlobal(lang: string): Observable<Translation>;
  loadScoped(scope: string, lang: string): Promise<any>;
}
